import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { DICT } from "../lib/i18n";

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("qamar_lang") || "ar");

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    localStorage.setItem("qamar_lang", lang);
  }, [lang]);

  const t = useCallback(
    (key, vars) => {
      let s = DICT[lang][key] ?? key;
      if (vars) Object.entries(vars).forEach(([k, v]) => (s = s.replace(`{${k}}`, v)));
      return s;
    },
    [lang]
  );

  // pick localized field: L(obj, "name") -> obj.name_ar / obj.name_en (fallback ar)
  const L = useCallback((obj, field) => (obj ? (lang === "en" && obj[`${field}_en`]) || obj[`${field}_ar`] || "" : ""), [lang]);

  const toggle = () => setLang((l) => (l === "ar" ? "en" : "ar"));

  return <LangContext.Provider value={{ lang, t, L, toggle, isRTL: lang === "ar" }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
